import { Redirect, Stack } from "expo-router";

import { useIsAuthenticated } from "@/stores/authStore";

export default function LandingLayout() {
  const isAuthenticated = useIsAuthenticated();

  if (isAuthenticated) {
    return <Redirect href="/(authed)" />;
  }

  return (
    <Stack screenOptions={{ headerShown: false }}>
      <Stack.Screen name="landing" />
      <Stack.Screen name="mfa-verify" />
      <Stack.Screen name="session-expired" />
      <Stack.Screen name="s/[code]" />
    </Stack>
  );
}
